import { paperMaterialBusiness } from "api/bussiness/paper-material/paper-material-bussiness";
import { createPaperMaterialOptionLabel } from "commons/ultilities/option-item/label-ultil";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import type { AutoCompleteProvider } from "./factory";

export const paperAutoCompleteProvider: AutoCompleteProvider = {
  searchOptionItemsAsync: async (keyword) => {
    return paperMaterialBusiness.searchPapersAsOptionItems(keyword);
  },
  searchOptionItemsPagedAsync: async (keyword, request) => {
    const papers = await paperMaterialBusiness.getLists({
      filter: keyword,
      maxResultCount: request.pageSize,
      skipCount: request.pageIndex * request.pageSize,
      sorting: "",
    });

    return {
      items: mapToDistinctOptionItems(
        papers.items,
        (item) => item.id,
        (item) => createPaperMaterialOptionLabel(item),
      ),
      totalCount: papers.totalCount,
    };
  },
  resolveSelectedOptionAsync: async (value) => {
    const normalizedId = String(value ?? "").trim();
    if (!normalizedId) {
      return null;
    }

    try {
      const paper = await paperMaterialBusiness.getById(normalizedId);
      if (!paper?.id) {
        return null;
      }

      return {
        value: paper.id,
        label: createPaperMaterialOptionLabel(paper),
      };
    } catch {
      return null;
    }
  },
};
